import { useState, useEffect } from 'react';
import { bookingRepository } from '../../../domain/bookingRepository';

export const useBookingList = () => {

    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setIsLoading(true);
        setError(null);
        bookingRepository.getBookingList()
            .then((list) => {
                setData(list);
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Failed to fetch booking list:", err);
                setError(err);
                setIsLoading(false);
            });
    }, []);

    return { data, isLoading, error };
}